import { getSessionId } from 'owa-analytics/lib/LazyAnalytics';
import { getClientId, getScriptPath, getBackend } from 'owa-config';

export default function() {
    return {
        UserAgent: window.navigator.userAgent,
        ScriptSource: getScriptPath(),
        SessionId: getSessionId(),
        ClientId: getClientId(),
        BEServer: getBackend(),
    };
}
